import { api } from '@src/constants/api';
import { createMiddleware } from '@src/utils';
import { securityActions } from '@src/store/reducers/securityReducer';

export const createSecurityMiddleware = (http: any, successPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [securityActions.TOKEN]: async (action: any) => {
            const response = await http({
                method: 'POST',
                url : `${restServiceUrl}Security/Token`,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: (obj: any) => {
                    const str = [];
                    for (const p in obj) {
                        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                    }
                    return str.join('&');
                },
                SilentRequest : action.silentRequest,
                transformResponse: (data: any, header: any) => {
                    return window['cTransformResponse'](data, header, action);
                },
                data: {
                    grant_type : 'password',
                    username : action.payload.username,
                    password: action.payload.password,
                    authType: action.payload.authType
                }
            });
            return response;
        },
        [securityActions.REFRESH_TOKEN]: async (action: any) => {
            //Security/RefreshToken
            //    console.log('Not implemented: REFRESH_TOKEN');
                //projectId is correct
                try{
                    const url = `${restServiceUrl}Security/RefreshToken`;
                    
                    const response = await http.post(url, action.payload );
                    return response;
                }
                catch(e){ 
                 //   sessionService.navigateToLoginPage();
                }
            
        },
        [securityActions.AUTHENTICATION_METHOD]: async () => {
            //Security/RefreshToken
            //    console.log('Not implemented: REFRESH_TOKEN');
                //projectId is correct
                try{
                    const url = `${restServiceUrl}Security/AuthenticationMethod`;
                    const response = await http.get(url);
                    //console.log(response)
                    return response;
                }
                catch(e){ 
                 //   sessionService.navigateToLoginPage();
                }
            
        },
        [securityActions.GET_OIDC_COfIGURATIONS]: async () => {
                try{
                    const url = `${restServiceUrl}Security/OidcConfigurations`;
                    const response = await http.get(url);
                    return response;
                }
                catch(e){ 
                 console.log(e)
                }
            
        },
        [securityActions.SET_OIDC_COfIGURATIONS]: async (action: any) => {
            try{
                const url = `${restServiceUrl}Security/OidcConfigurations?reloadServices=${action.payload.flag}`;
                //console.log(action.payload.configData)
                const response = await http.post(url,action.payload.configData);
                if(response.data)
                {
                    successPopUp();
                }
                else
                {
                    console.log(response);
                }
                return response;
            }
            catch(e){ 
             console.log(e)
            }
        
    },
        [securityActions.LOGOUT]: async (action: any) => {
/*
            next({ type: securityActions.LOGOUT_SUCCESS });
*/
            if (action.callback != null) {
                action.callback();
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/security.middleware.ts